export default __webpack_public_path__ + "static/media/ico-folder.f94ead48.png";